module.exports = __webpack_public_path__ + "media/native-apps/norrkoping-395a564b.webp";